import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useTranslation } from 'react-i18next';

type ProductAlertButtonProps = {
  onPress: () => void;
};

export const ProductAlertButton = ({ onPress }: ProductAlertButtonProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.alertButtonContainer}>
      <TouchableOpacity
        style={styles.alertButton}
        onPress={onPress}
      >
        <MaterialCommunityIcons
          name="bell-plus"
          color={Colors.blackText}
          size={16}
          style={styles.icon}
        />
        <Text style={styles.label}>{t('alerts.createAlert')}</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  alertButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  alertButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16,
    height: 32,
    backgroundColor: Colors.white,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.primaryGrayHeader,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: -0.25,
  },
});